import { Layout } from '../components/Layout'
import { MentalHealth } from '../components/mental-health/MentalHealth'

const Depression = () => {
  return (
    <Layout>
      <MentalHealth condition="depression" />
    </Layout>
  )
}

export default Depression
